// extracted by mini-css-extract-plugin
module.exports = {"form__title":"hLpPa","form__input":"_2-PRK"};